import styled from 'styled-components'

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 100%;
`

export const CreateOrderSection = styled.div`
  margin-bottom: 0.5rem;

  hr {
    margin: 0.75rem 0;
    border: none;
    border-top: 1px solid var(--sidebar-separator);
  }
`

export const CreateOrderLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 0.3rem;
  color: var(--sidebar-text-color);
  text-decoration: none;
  border-radius: 4px;
  font-weight: bold;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: var(--sidebar-hover-bg);
    color: var(--sidebar-text-color);
  }

  i.icon {
    margin-right: 0;
  }
`

export const OverviewSection = styled.div`
  margin-bottom: 0.5rem;

  hr {
    margin: 0.75rem 0;
    border: none;
    border-top: 1px solid var(--sidebar-separator);
  }
`

export const FilterList = styled.div`
  display: flex;
  flex-direction: column;
`

export const FilterItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.7rem 0.3rem;
  color: var(--sidebar-text-color);
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.15s ease;

  .ui.label {
    background-color: var(--sidebar-label-bg);
    color: var(--sidebar-label-color);
  }

  &:hover {
    background-color: var(--sidebar-hover-bg);
    color: var(--sidebar-text-color);

    .ui.label {
      background-color: var(--sidebar-label-hover-bg);
      color: var(--sidebar-label-hover-color);
    }
  }

  &.active {
    background-color: var(--sidebar-hover-bg);
    color: var(--sidebar-text-color);
    font-weight: bold;

    .ui.label {
      background-color: var(--sidebar-label-hover-bg);
      color: var(--sidebar-label-hover-color);
    }
  }

  &.active-alert {
    color: var(--sidebar-text-color);

    i.icon {
      color: var(--red);
    }

    .ui.label {
      background-color: var(--red);
      color: white;
    }
  }
`

export const FilterItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;

  i.icon {
    margin-right: 0;
    width: 1.2em;
    flex-shrink: 0;
  }
`

export const FilterDivider = styled.hr`
  margin: 0.75rem 0;
  border: none;
  border-top: 1px solid var(--sidebar-separator);
`

export const OverviewLink = styled.a`
  display: flex;
  align-items: center;
  position: relative;
  gap: 0.5rem;
  padding: 0.7rem 0.3rem;
  color: var(--sidebar-text-color);
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.15s ease;
  margin-bottom: 0;

  &:hover {
    background-color: var(--sidebar-hover-bg);
    color: var(--sidebar-text-color);
  }

  &.active {
    background-color: var(--sidebar-hover-bg);
    color: var(--sidebar-text-color);
    font-weight: bold;
  }

  i.icon {
    margin-right: 0;
  }

  .ui.label.beta-label {
    position: absolute;
    right: 0.3rem;
    background-color: var(--primary);
    color: var(--sidebar-text-color);
  }
`

export const StreetTurnsLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.7rem 0.3rem;
  color: var(--sidebar-text-color);
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.15s ease;

  .ui.label {
    background-color: var(--sidebar-label-bg);
    color: var(--sidebar-label-color);
  }

  &:hover {
    background-color: var(--sidebar-hover-bg);
    color: var(--sidebar-text-color);

    .ui.label {
      background-color: var(--sidebar-label-hover-bg);
      color: var(--sidebar-label-hover-color);
    }
  }

  &.active {
    background-color: var(--sidebar-hover-bg);
    color: var(--sidebar-text-color);
    font-weight: bold;

    .ui.label {
      background-color: var(--sidebar-label-hover-bg);
      color: var(--sidebar-label-hover-color);
    }
  }
`

export const StreetTurnsContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  i.icon {
    margin-right: 0;
  }
`

export const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  color: var(--sidebar-text-color);
  opacity: 0.7;
  font-size: 0.9rem;
`

export const FiltersSection = styled.div`
  margin-bottom: 0.5rem;

  hr {
    margin: 0.75rem 0;
    border: none;
    border-top: 1px solid var(--sidebar-separator);
  }
`
